import _ from 'lodash';
import Vue from 'vue';
import { actionsToMutations } from '../utils';

import {
  STORE_API_ERRORS,
  DELETE_API_ERROR,
  GET_ERRORS,
  CONTEXT_CREATE,
  CONTEXT_DESTROY,
  STORE_SUCCESS_MESSAGE,
} from './types';

export default {
  namespaced: true,
  state: {
    apiErrors: {},
    successMsg: {},
  },
  getters: {
    [GET_ERRORS](state) {
      return (context: string, path: string) => {
        return _.get(state.apiErrors[context], path);
      };
    },
  },
  mutations: {
    [CONTEXT_CREATE](state, { context }) {
      Vue.set(state.apiErrors, context, {});
    },
    [CONTEXT_DESTROY](state, { context }) {
      Vue.delete(state.apiErrors, context);
    },
    [STORE_API_ERRORS](state, { context, errors }) {
      Vue.set(state.apiErrors, context, errors);
    },
    [DELETE_API_ERROR](state, { context, path }) {
      if (_.get(state.apiErrors[context], path)) {
        Vue.set(
          state.apiErrors,
          context,
          _.omit(state.apiErrors[context], path) as any,
        );
      }
    },
    [STORE_SUCCESS_MESSAGE](state, payload) {
      state.successMsg = { ...payload };
    },
  },
  actions: {
    ...actionsToMutations([
      CONTEXT_CREATE,
      CONTEXT_DESTROY,
      STORE_API_ERRORS,
      DELETE_API_ERROR,
      STORE_SUCCESS_MESSAGE,
    ]),
  },
};
